import { Typography, useTheme } from '@material-ui/core';
import { StarOutline, HighlightOff, NoteAdd } from '@material-ui/icons';
import { withStyles } from '@material-ui/styles';
import { Card, LinkButton } from 'bc-front-sagacomponents';
import Depannage from '../../../images/Depannage';
import Fidelite from '../../../images/Fidelite';
import Information from '../../../images/Information';
import Remboursement from '../../../images/Remboursement';
import Renouvellement from '../../../images/Renouvellement';
import history from '../../../services/history';
import styles from '../style';

interface Props {
  hasServiceFidelisation: boolean;
  hasListeProduits: boolean;
  hasRemboursement: boolean;
  hasRemorquageDepannage: boolean;
  hasRenouvellemement: boolean;
  hasResiliation: boolean;
  classes?: any;
  setOpenAjoutAdherent(param: boolean): void;
  listeAdhesions: any;
}
const MenuPro = (props: Props) => {
  const {
    classes,
    hasServiceFidelisation,
    hasListeProduits,
    hasRemboursement,
    hasRemorquageDepannage,
    setOpenAjoutAdherent,
    hasRenouvellemement,
    hasResiliation,
    listeAdhesions,
  } = props;

  const theme = useTheme();
  return (
    <div>
      {hasRemorquageDepannage && (
        <Card red>
          <Typography variant="h3">Assistance dépannage</Typography>
          <LinkButton
            color="secondary"
            onClick={() => history.push('/depannage')}
            title={'Lancer le dépannage'}
            icon={<Depannage width={22} />}
          />
        </Card>
      )}
      {hasRemboursement && (
        <Card>
          <Typography variant="h3">Mes demandes</Typography>
          {hasRemboursement && (
            <LinkButton
              color="primary"
              onClick={() => history.push('/demande-remboursement')}
              title={'Demande de remboursement'}
              icon={<Remboursement width={20} />}
            />
          )}
        </Card>
      )}
      <Card
        red={!hasRemorquageDepannage && !hasRemboursement}
        className={(!hasRemorquageDepannage && !hasRemboursement && classes.menuRed) || undefined}
      >
        <Typography variant="h3">Mes contrats</Typography>
        {listeAdhesions && (
          <LinkButton
            color={!hasRemorquageDepannage && !hasRemboursement ? 'secondary' : 'primary'}
            onClick={() => history.push('/contrats?informations')}
            title={'Mes informations'}
            icon={<Information width={10} />}
          />
        )}
        {hasListeProduits && (
          <LinkButton
            color={!hasRemorquageDepannage && !hasRemboursement ? 'secondary' : 'primary'}
            onClick={() => history.push('/contrats?avantage')}
            title={'Mes avantages'}
            icon={<StarOutline width={15} className={classes.iconStar} />}
          />
        )}
        {hasRenouvellemement && (
          <LinkButton
            color={!hasRemorquageDepannage && !hasRemboursement ? 'secondary' : 'primary'}
            onClick={() => history.push('/contrats?renouvellement')}
            title={'Renouvellement'}
            icon={<Renouvellement width={20} />}
          />
        )}
        {hasResiliation && (
          <LinkButton
            color={!hasRemorquageDepannage && !hasRemboursement ? 'secondary' : 'primary'}
            onClick={() => history.push('/contrats?resiliation')}
            title={'Résiliation'}
            icon={<HighlightOff width={20} className={classes.iconStar} />}
          />
        )}
        {/* not added to menu for [Production] */}
        {hasServiceFidelisation && !window.location.hostname.startsWith('part') && (
          <LinkButton
            color={!hasRemorquageDepannage && !hasRemboursement ? 'secondary' : 'primary'}
            onClick={() => history.push('/contrats?fidelite')}
            title={'Mon programme de fidélité'}
            icon={
              <Fidelite
                width={20}
                fill={!hasRemorquageDepannage && !hasRemboursement ? theme.palette.primary.main : 'white'}
              />
            }
          />
        )}{' '}
        <LinkButton
          color={!hasRemorquageDepannage && !hasRemboursement ? 'secondary' : 'primary'}
          onClick={() => setOpenAjoutAdherent(true)}
          title={'Ajouter un contrat'}
          icon={<NoteAdd width={20} className={classes.iconStar} />}
        />
      </Card>
    </div>
  );
};
export default withStyles(styles)(MenuPro);
